// extracted by extract-css-chunks-webpack-plugin
module.exports = {"_sharedGrid":"button___sharedGrid--2hfs6","button":"button__button--1jVVZ","marginRight":"button__marginRight--2g-lG","marginLeft":"button__marginLeft--tcTq-"};